import { ScrollingModule } from '@angular/cdk/scrolling';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { TablerIconsModule } from 'angular-tabler-icons';
import * as TablerIcons from 'angular-tabler-icons/icons';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { NgxLoadingButtonsModule } from 'ngx-loading-buttons';
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthModule } from './auth/auth.module';
import { CallbackComponent } from './callback/callback.component';
import { FileModule } from './file/file.module';
import { GestionProveedoresModule } from './gestion-proveedores/gestion-proveedores.module';
import { IncidenciasModule } from './incidencias/incidencias.module';
import { MaterialModule } from './material/material.module';
import { NotificacionesComponent } from './notificaciones/notificaciones.component';
import { OrdenCompraModule } from './orden-compra/orden-compra.module';
import { ProgramacionAventuraModule } from './programacion-aventura/programacion-aventura.module';
import { FileService } from './services/api/file.service';
import { AuthInterceptor } from './services/interceptors/auth-interceptor';
import { ErrorsInterceptorService } from './services/interceptors/errors-interceptor.service';
import { LoadingInterceptorService } from './services/interceptors/loading-interceptor.service';
import { ServicesMapperService } from './services/mapper/servicesMapper.service';

@NgModule({
  declarations: [AppComponent, NotificacionesComponent, CallbackComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    TablerIconsModule.pick(TablerIcons),
    NgxLoadingButtonsModule,
    MatDialogModule,
    MatIconModule,
    ScrollingModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    AuthModule,
    GestionProveedoresModule,
    IncidenciasModule,
    FileModule,
    OrdenCompraModule,
    ProgramacionAventuraModule,
    BrowserAnimationsModule,
    MaterialModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    SweetAlert2Module.forRoot(),
    NgxExtendedPdfViewerModule,
    ToastrModule.forRoot()
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptorService,
      multi: true
    },

    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorsInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'en-GB'
    },
    FileService,
    ServicesMapperService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
